import { StoreConstants } from "src/app/constants/StoreConstants";
import { LearnerCourseState } from "./learner-course.state";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { LearnerCourse, LearnerCoursesList, UpdateLearnerCourseDto } from "src/app/_models/LearnerCourse";
import { MessageResultDto } from "src/app/_models/MessageResultDto";
import { HttpErrorResponse } from "@angular/common/http";
import { LearnerCourseLog } from "src/app/_models/LearnerCourseLog";
import { Course } from "src/app/_models/Course";

export const selectLearnerCourseState =
  createFeatureSelector<LearnerCourseState>(StoreConstants.STATE_LCS);

export const selectLearnerCoursesList = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): LearnerCoursesList[] => state.result
);

export const selectLearnerCoursesListLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.loader
);

export const selectUpdateLearnerCoursesResult = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): MessageResultDto => state.messageResult
);

export const selectUpdateDisableLearnerCourseLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.updateDisableLoader
);

export const selectUpdateLearnerCoursesResultError = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): HttpErrorResponse => state.error
);

export const selectReAssignResult = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): number => state.reAssignResult
);

export const selectReAssignLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.reAssignLoader
);

export const selectReAssignError = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): HttpErrorResponse => state.reAssignError
);

export const selectGenerateLearningPlanResult = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): number => state.generateLearningPlanResult
);

export const selectGenerateLearningPlanLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.generateLearningPlanLoader
);

export const selectGenerateLearningPlanError = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): HttpErrorResponse => state.generateLearningPlanError
);

export const selectLearnerCourseLog = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): LearnerCourseLog => state.learnerCourseLog
);

export const selectLearnerCourseLogLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.learnerCourseLogLoader
);

export const selectLearnerCourseLogError = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): HttpErrorResponse => state.learnerCourseLogError
);

export const selectLearnerCourseResult = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): LearnerCourse => state.learnerCourse
);

export const selectLearnerCourseLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.learnerCourseLoader
);

export const selectLearnerCourseError = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): any => state.learnerCourseError
);

export const selectUpdateLearnerCourseResult = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): UpdateLearnerCourseDto => state.updateLearnerCourseResult
);

export const selectUpdateLearnerCourseLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.updateLearnerCourseLoader
);

export const selectUpdateLearnerCourseError = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): any => state.updateLearnerCourseError
);

export const selectLearnerCourseLogStatus = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): LearnerCourseLog => state.learnerCourseLogStatus
);

export const selectLearnerCourseLogStatusLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.learnerCourseLogStatusLoader
);

export const selectLearnerCourseLogStatusError = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): HttpErrorResponse => state.learnerCourseLogStatusError
);

export const selectAssignCourseToMultipleLearners = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.addLearnerCourseListResult
);

export const selectAssignCourseToMultipleLearnersLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.addLearnerCourseListLoader
);

export const selectAssignCourseToMultipleLearnersError = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): HttpErrorResponse => state.addLearnerCourseListError
);

export const selectLearnerCourseScreenerResult = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): Course[] => state.learnerCourseScreenerResult
);

export const selectLearnerCourseScreenerLoader = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): boolean => state.learnerCourseScreenerLoader
);

export const selectLearnerCourseScreenerError = createSelector(
  selectLearnerCourseState,
  (state: LearnerCourseState): HttpErrorResponse => state.learnerCourseScreenerError
);